import client from "./client";


const ripplingEmployees = async (params="") => {
    let res: any = await client.get("/rippling/employees", params);
    return res;
  };



const ripplingService = {
    ripplingEmployees
  };
  
  export default ripplingService;